import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { required, numericRange } from '@mhub/web-validations';
import {
  Button,
  Grid,
  Header,
  Form as SemanticForm,
  Icon,
  Label,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import { flashSuccessMessage } from '../../actions/flash';

import AppForm from '../../components/AppForm';
import SelectBank from '../../components/AppForm/SelectBank';
import UploadModal from '../../components/UploadModal';

import PAYMENT_TYPES from '../../constants/paymentTypes';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { VA_ACCOUNT_NUMBER, VA_BANK_NAME } from '../../constants/virtualAccount';

import UploadAttachmentForm from '../BookingPaymentPictures/Form';

import PaymentRequestModal from '../modals/PaymentRequest';
import NotifyAddPurchaserEmailModal from '../modals/NotifyAddPurchaserEmail';

import BOOKING_DEFAULT from '../../structs/booking';

import { resetDataChanges } from '../../utils/inputChanges';
import { validateForm } from '../../utils/validations';
import { floatToCents } from '../../utils/numbers/centsFloat';
import config from '../../../config';

const isPRS = config.get('prs');

class Form extends Component {
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        onlinePaymentEnabled: PropTypes.bool,
        settings: PropTypes.shape({
          virtualAccountIsEnabled: PropTypes.bool,
        }),
      }),
    }),
    checkChanges: PropTypes.func,
    bookingData: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    onCreate: PropTypes.func,
    projectBankAccount: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    resetChanges: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultBookingFeePayment = {
    bookingID: '',
    creditCardLastFourDigits: '',
    paymentMethodTypeID: isPRS ? 'cheque' : '',
    paymentMethodType: {
      name: '',
    },
    cancelledReason: '',
    amountCents: '',
    paymentPictures: [],
    reference: '',
    status: '',
    transferredToBankID: '',
    transferredFromBank: '',
    transferredFromAccountNumber: '',
    transferredToVABank: '',
    transferredToVAAccountNumber: '',
  };
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    this.validation = {
      transferredToBankID: createRef(),
      transferredFromBank: createRef(),
      transferredFromAccountNumber: createRef(),
      creditCardLastFourDigits: createRef(),
      paymentMethodTypeID: createRef(),
      amountCents: createRef(),
      reference: createRef(),
      transferredToVAAccountNumber: createRef(),
    };
    const state = this.getPropsToState(props);
    this.state = {
      loading: false,
      picturesUploaded: {},
      picturesUploadedCount: 0,
      openPaymentRequestModal: false,
      openNotifyAddPurchaserEmailModal: false,
      ...state,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = this.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const isTablet = windowWidth >= 768 && windowWidth < 992;
    const data = Object.assign({}, Form.defaultBookingFeePayment, props.data);
    const bookingData = Object.assign({}, BOOKING_DEFAULT, props.bookingData);
    const projectBankAccount = this.transformProjectBankAccountData(props.projectBankAccount);
    let vaBankName = '';
    let vaAccountNumber = '';
    if (bookingData && bookingData.projectUnit && bookingData.projectUnit.projectUnitCustomFields && bookingData.projectUnit.projectUnitCustomFields.length > 0) {
      const pucfs = bookingData.projectUnit.projectUnitCustomFields;
      vaBankName = pucfs.some(pucf => pucf.projectUnitCustomFieldSettingID === VA_BANK_NAME) ? pucfs.find(pucf => pucf.projectUnitCustomFieldSettingID === VA_BANK_NAME).value : '';
      vaAccountNumber = pucfs.some(pucf => pucf.projectUnitCustomFieldSettingID === VA_ACCOUNT_NUMBER) ? pucfs.find(pucf => pucf.projectUnitCustomFieldSettingID === VA_ACCOUNT_NUMBER).value : '';
    }
    return {
      data,
      bookingData,
      isMobile,
      isTablet,
      projectBankAccount,
      vaBankName,
      vaAccountNumber,
    };
  }
  paymentTypes() {
    const { bookingData } = this.state;
    const { t } = this.props;
    const paymentTypes = [];
    const hasOnlinePayment = this.props.appConfig.data.onlinePaymentEnabled;
    const hasVirtualAccountPayment = this.props.appConfig.data.settings.virtualAccountIsEnabled;
    const isMPBooking = bookingData && bookingData.origin.includes('marketplace');
    PAYMENT_TYPES.forEach((item) => {
      const newItem = Object.assign({}, item);
      bookingData.project.paymentTypeOptions.forEach((value) => {
        if (value === item.value) {
          if (newItem.value === 'online_payment') {
            newItem.disabled = !hasOnlinePayment || isMPBooking;
          }
          paymentTypes.push(newItem);
        }
      });
      if (newItem.value === 'virtual_account' && hasVirtualAccountPayment) {
        paymentTypes.push(newItem);
      }
    });
    return paymentTypes.map(pt => ({
      ...pt,
      text: t(pt.text, { ns: TRANSLATION_FILES.constants }),
    }));
  }
  handleInputChange = (event, { name, value }) => {
    const { data, bookingData, vaAccountNumber, vaBankName } = this.state;
    if (
      name === 'paymentMethodTypeID' && value === 'online_payment' &&
      bookingData && bookingData.bookingCustomer && bookingData.bookingCustomer.email === '') {
      this.setState({ openNotifyAddPurchaserEmailModal: true });
      return;
    }
    // If bank_transfer & only got one option in the bank dropdown, have it selected automatically
    if (name === 'paymentMethodTypeID' && value === 'bank_transfer') {
      const { projectBankAccount } = this.state;
      if (projectBankAccount && projectBankAccount.length === 1) {
        data.transferredToBankID = projectBankAccount[0].value;
      }
    }
    if (this.props.checkChanges) this.props.checkChanges('isBookingFeePaymentChanged');
    if (name === 'transferredToVAAccountNumber') {
      data.transferredToVABank = vaBankName;
      data.transferredToVAAccountNumber = vaAccountNumber;
    } else {
      data[name] = value;
    }
    this.setState({ data });
  }
  handleCloseModal = (e) => {
    e.preventDefault();
    const { openPaymentRequestModal, openNotifyAddPurchaserEmailModal } = this.state;
    if (openPaymentRequestModal) {
      this.setState({ openPaymentRequestModal: false });
    }
    if (openNotifyAddPurchaserEmailModal) {
      this.setState({ openNotifyAddPurchaserEmailModal: false });
    }
  }
  handleOnAddEmail = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { bookingData } = this.state;
    this.setState({ openNotifyAddPurchaserEmailModal: false });
    if (bookingData) {
      store.dispatch(push(`/bookings/${bookingData.id}/?section=purchaser`));
    }
  }
  handleResetInputChange = (sectionName = 'BookingFeePayment') => {
    const { oriData } = this.state;
    const data = resetDataChanges(oriData, Form.defaultBookingFeePayment);
    this.setState({ data }, () => {
      if (this.props.resetChanges) this.props.resetChanges(sectionName);
    });
  }
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const isTablet = windowWidth >= 768 && windowWidth < 992;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
    if (isTablet !== this.state.isTablet) {
      this.setState({ isTablet });
    }
  }
  handleSave = (event) => {
    event.preventDefault();
    const { store } = this.context;
    const { bookingData, data, openPaymentRequestModal, picturesUploaded, picturesUploadedCount } = this.state;
    if (openPaymentRequestModal) {
      this.setState({ openPaymentRequestModal: false });
    }
    if (data.creditCardLastFourDigits && data.paymentMethodTypeID !== 'credit_card') {
      data.creditCardLastFourDigits = '';
    }
    if (data.paymentMethodTypeID !== 'virtual_account') {
      data.transferredToVABankName = '';
      data.transferredToVAAccountNumber = '';
    }
  // handleSendRequestPayment
    return AppForm.validate(this.validation, data)
      .then((validations) => {
        const nValidations = validations;
        const project = bookingData.project;
        if ((project && project.paymentFieldsRequired && data.paymentMethodTypeID !== 'online_payment')
        || (isPRS && data.paymentMethodTypeID === 'cheque' && picturesUploadedCount < 1)
        ) {
          nValidations.push({
            isValid: picturesUploadedCount > 0,
            key: '',
            message: 'File attachment is required',
          });
        }
        if (validateForm(store, nValidations)) return;

        let newAmountCents = data.amountCents;
        if (newAmountCents[newAmountCents.length - 1] === '.') {
          newAmountCents = newAmountCents.slice(0, -1);
        }
        this.props.onCreate({
          data: {
            ...data,
            amountCents: floatToCents(newAmountCents),
          },
          picturesUploaded,
          picturesUploadedCount,
        });
      });
  }
  handleSendRequestPayment = (e) => {
    e.preventDefault();
    this.setState({ openPaymentRequestModal: true });
  }
  handleUploadModalClose = () => this.uploadModal.close();
  transformProjectBankAccountData = (projectBankAccount) => {
    if (!projectBankAccount) return [];
    const activeBankAccount = projectBankAccount.filter(e => e.isActive);
    return activeBankAccount.map(e => ({
      value: e.id,
      text: `${e.bank} (${e.accountNumber})`,
    }));
  }
  transformUnitVAData = () => {
    const { vaAccountNumber, vaBankName } = this.state;
    const { t } = this.props;
    let vaOptions = [{
      value: '-',
      text: t('Not available'),
    }];
    if (vaBankName && vaAccountNumber) {
      vaOptions = [{
        value: vaAccountNumber,
        text: `${vaBankName} (${vaAccountNumber})`,
      }];
    }
    return vaOptions;
  }
  async uploadPictures(e, body) {
    e.preventDefault();
    const { store } = this.context;
    const { t } = this.props;
    this.setState({
      picturesUploaded: body,
      picturesUploadedCount: body.get('total_attached'),
    });
    this.uploadModal.close();
    store.dispatch(flashSuccessMessage({
      header: t('Attached', { ns: TRANSLATION_FILES.translation }),
      message: t('Picture(s) attached', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  renderConditionalFieldsBasedOnPaymentMethod() {
    const { data, isMobile, isTablet, projectBankAccount = [] } = this.state;
    const { auth, t } = this.props;
    let toRender = null;
    switch (data.paymentMethodTypeID) {
      case 'bank_transfer':
      case 'virtual_account':
        toRender = (
          <span>
            {
              data.paymentMethodTypeID === 'bank_transfer' && projectBankAccount.length > 0 ? (
                <Grid verticalAlign="middle">
                  <Grid.Column textAlign="left" width={4}>
                    <b>{t('Transferred to')}</b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={12}>
                    <AppForm.Validate
                      hideMessage
                      validateLabel={t('Transferred to')}
                      ref={this.validation.transferredToBankID}
                      onChange={this.handleInputChange}
                    >
                      <SemanticForm.Select
                        fluid
                        label=""
                        name="transferredToBankID"
                        options={projectBankAccount}
                        placeholder={t('Select {{title}}', { title: t('Account') })}
                        selectOnBlur={false}
                        value={data.transferredToBankID}
                      />
                    </AppForm.Validate>
                  </Grid.Column>
                </Grid>
              ) : null
            }
            {
              data.paymentMethodTypeID === 'virtual_account' && (
                <Grid verticalAlign="middle">
                  <Grid.Column textAlign="left" width={4}>
                    <b>{t('Transferred to')}</b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={12}>
                    <AppForm.Validate
                      hideMessage
                      validateLabel={t('Transferred to')}
                      validation={[required]}
                      ref={this.validation.transferredToVAAccountNumber}
                      onChange={this.handleInputChange}
                    >
                      <SemanticForm.Select
                        fluid
                        label=""
                        name="transferredToVAAccountNumber"
                        options={this.transformUnitVAData()}
                        placeholder={t('Select {{title}}', { title: t('Account') })}
                        selectOnBlur={false}
                        value={data.transferredToVAAccountNumber}
                      />
                    </AppForm.Validate>
                  </Grid.Column>
                </Grid>
              )
            }
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={4}>
                <b>{t('Transferred from')}</b>
              </Grid.Column>
              <Grid.Column textAlign="right" width={12}>
                <SelectBank
                  country={auth && auth.company ? auth.company.countryCode : ''}
                  fullWidth={isMobile || isTablet}
                  validateLabel={t('Transferred from')}
                  ref={this.validation.transferredFromBank}
                  onChange={this.handleInputChange}
                  name="transferredFromBank"
                  placeholder={t('Select {{title}}', { title: t('Bank') })}
                  value={data.transferredFromBank}
                />
              </Grid.Column>
            </Grid>
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={4} />
              <Grid.Column textAlign="right" width={12}>
                <AppForm.Input
                  type="text"
                  hideMessage
                  name="transferredFromAccountNumber"
                  validateLabel={t('Account number')}
                  value={data.transferredFromAccountNumber}
                  onChange={this.handleInputChange}
                  ref={this.validation.transferredFromAccountNumber}
                  placeholder={t('Account number')}
                />
              </Grid.Column>
            </Grid>
          </span>
        );
        break;
      case 'cheque':
        toRender = projectBankAccount.length > 0 ? (
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={4}>
              <b>{t('Transferred to')}</b>
            </Grid.Column>
            <Grid.Column textAlign="right" width={12}>
              <AppForm.Validate
                hideMessage
                validateLabel={t('Transferred to')}
                ref={this.validation.transferredToBankID}
                onChange={this.handleInputChange}
              >
                <SemanticForm.Select
                  fluid
                  label=""
                  name="transferredToBankID"
                  options={projectBankAccount}
                  placeholder={t('Select {{title}}', { title: t('Account') })}
                  selectOnBlur={false}
                  value={data.transferredToBankID}
                />
              </AppForm.Validate>
            </Grid.Column>
          </Grid>
        ) : null;
        break;
      case 'credit_card':
        toRender = (
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="left" width={4}>
              <b>{t('Card Number')}</b>
            </Grid.Column>
            <Grid.Column textAlign="right" width={8}>
              <Header as="h3">XXXX XXXX XXXX</Header>
            </Grid.Column>
            <Grid.Column textAlign="right" width={4}>
              <AppForm.Input
                type="number"
                hideMessage
                name="creditCardLastFourDigits"
                validateLabel={t('Last four digits of credit card')}
                value={data.creditCardLastFourDigits}
                onChange={this.handleInputChange}
                ref={this.validation.creditCardLastFourDigits}
              />
            </Grid.Column>
          </Grid>
        );
        break;
      default:
        break;
    }
    return toRender;
  }
  render() {
    const { bookingData, data } = this.state;
    const { t } = this.props;
    const project = bookingData.project;
    return (
      <Grid.Row>
        <Grid.Column mobile={15} tablet={15} computer={15} className="payment-card">
          <AppForm
            onSubmit={this.handleSave}
          >
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={4}>
                <b>{t('Payment Method')}</b>
              </Grid.Column>
              <Grid.Column textAlign="right" width={7}>
                <AppForm.Validate
                  hideMessage
                  validation={[required]}
                  validateLabel={t('Payment Method')}
                  ref={this.validation.paymentMethodTypeID}
                  onChange={this.handleInputChange}
                >
                  <SemanticForm.Select
                    fluid
                    label=""
                    name="paymentMethodTypeID"
                    options={this.paymentTypes()}
                    placeholder={t('Payment Method')}
                    selectOnBlur={false}
                    value={data.paymentMethodTypeID}
                    disabled={isPRS}
                  />
                </AppForm.Validate>
              </Grid.Column>
              { data.paymentMethodTypeID !== 'online_payment' &&
                <Grid.Column textAlign="left" width={5}>
                  <UploadModal
                    trigger={(
                      <span>
                        <a><Icon name="upload" />{t('Attachment')} </a>
                        {
                          this.state.picturesUploadedCount > 0 ? (
                            <Label color="blue" circular size="tiny">
                              {this.state.picturesUploadedCount}
                            </Label>
                          ) : null
                        }
                      </span>
                    )}
                    ref={(ref) => { this.uploadModal = ref; }}
                    header="pictures"
                    loading={this.state.loading}
                    onConfirm={(e, file) => {
                      this.uploadPictures(e, file);
                    }}
                    onClose={this.handleUploadModalClose}
                    primary={false}
                    content={opt => (
                      <UploadAttachmentForm
                        fileType="attachment"
                        loading={this.state.loading}
                        onSubmit={opt.onConfirm}
                      />
                    )}
                  />
                </Grid.Column>
              }
            </Grid>
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={4}>
                <b>{t('Amount')}</b>
              </Grid.Column>
              <Grid.Column textAlign="right" width={12}>
                <AppForm.Input
                  showThousandSeparator
                  hideMessage
                  name="amountCents"
                  validateLabel={t('Amount')}
                  value={data.amountCents}
                  onChange={this.handleInputChange}
                  ref={this.validation.amountCents}
                  validation={[required, {
                    validate: numericRange,
                    option: {
                      min: 0.1,
                    },
                  }]}
                />
              </Grid.Column>
            </Grid>
            {
              this.renderConditionalFieldsBasedOnPaymentMethod()
            }
            {
              data.paymentMethodTypeID !== 'online_payment' ? (
                <Grid verticalAlign="middle">
                  <Grid.Column textAlign="left" width={4}>
                    <b>{t('Reference')}</b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={12}>
                    <AppForm.Input
                      hideMessage
                      name="reference"
                      value={data.reference}
                      onChange={this.handleInputChange}
                      ref={this.validation.reference}
                      validation={(project && project.paymentFieldsRequired) ? [required] : null}
                      validateLabel={t('Reference')}
                    />
                  </Grid.Column>
                </Grid>
              ) : null
            }
            <Grid verticalAlign="middle">
              { data.paymentMethodTypeID !== 'online_payment' ? (
                <Grid.Column textAlign="left" only="tablet computer" tablet={6} computer={7} />
              ) : (
                <Grid.Column textAlign="left" only="computer" computer={4} />
              )
              }
              <Grid.Column textAlign="right" mobile={16} tablet={5} computer={5}>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleResetInputChange('BookingFeePayment');
                  }}
                  fluid
                  basic
                  content={t('Cancel', { ns: TRANSLATION_FILES.translation })}
                />
              </Grid.Column>
              {
                data.paymentMethodTypeID !== 'online_payment' ? (
                  <Grid.Column textAlign="right" mobile={16} tablet={5} computer={4}>
                    <Button
                      fluid
                      color="blue"
                      onClick={this.handleSave}
                      content={t('Save', { ns: TRANSLATION_FILES.translation })}
                    />
                  </Grid.Column>
                ) : (
                  <Grid.Column textAlign="right" mobile={16} tablet={11} computer={7}>
                    <Button
                      fluid
                      color="blue"
                      onClick={this.handleSendRequestPayment}
                      content={t('Send Request Payment')}
                    />
                  </Grid.Column>
                  )
                }
              <Grid.Column>
                <PaymentRequestModal
                  open={this.state.openPaymentRequestModal}
                  onClose={e => this.handleCloseModal(e)}
                  onConfirm={e => this.handleSave(e)}
                />
              </Grid.Column>
              <Grid.Column>
                <NotifyAddPurchaserEmailModal
                  open={this.state.openNotifyAddPurchaserEmailModal}
                  onClose={e => this.handleCloseModal(e)}
                  onAddEmail={e => this.handleOnAddEmail(e)}
                  isMobile={this.state.isMobile}
                />
              </Grid.Column>
            </Grid>
          </AppForm>
        </Grid.Column>
      </Grid.Row>
    );
  }
}
export default withTranslation(namespaces)(connect(Form.mapStateToProps)(Form));



// WEBPACK FOOTER //
// ./src/containers/BookingPayment/Form.jsx